import React, { Component } from 'react';
import { Link } from 'react-router-dom'

class Home extends Component {
  render() {
    return (
        <main role="main">

          {/* Main jumbotron for a primary marketing message or call to action */}
          <div className="jumbotron">
            <div className="container">
              <h1 className="display-3">Happy API</h1>
              <p>The Happy API is a high performance, universal programming interface that provides developers fast, reliable integration with HappyCo’s platform. An overview of how the API works is available <a href="https://hpy.io/api-overview">here</a>.</p>
              <p><Link to="/guides" className="btn btn-primary btn-lg" >Learn more &raquo;</Link></p>
            </div>
          </div>

          <div className="container">
            {/* Example row of columns */}
            <div className="row">
              <div className="col-md-4">
                <h2>Automate scheduling inspections</h2>
                <p>Automatically schedule move-in, move-out, routing maintenance and other kinds of inspections directly in HappyCo.</p>
                <p><a className="btn btn-secondary" href="/" role="button">View details &raquo;</a></p>
              </div>
              <div className="col-md-4">
                <h2>Analyze your data</h2>
                <p>Pull all of your data out, to send it to your data warehouse or run custom analytics.</p>
                <p><a className="btn btn-secondary" href="/" role="button">View details &raquo;</a></p>
              </div>
              <div className="col-md-4">
                <h2>Two-way sync</h2>
                <p>Keep the information in HappyCo data up-to-date with all your systems.</p>
                <p><a className="btn btn-secondary" href="/" role="button">View details &raquo;</a></p>
              </div>
            </div>

            <hr />

          </div> {/* /container */}

        </main>
    );
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/Home.js